import * as React from 'react';

import PrimaryLayout from '../layouts/PrimaryLayout';
import PageIntro from '../components/layout/PageIntro';
import PlatformCardGrid from '../components/layout/PlatformCardGrid';

const ChangelogPage: React.FunctionComponent = () => {
  const title = 'Changelog';
  const slug = '/changelog/';

  return (
    <PrimaryLayout title={title} path={slug}>
      <PageIntro title={title} path={slug} />
      <PlatformCardGrid link="changelog" />
    </PrimaryLayout>
  );
};

export default ChangelogPage;
